export const CONCATENATED_TABLE_REGEX = /^\s*\|.*\|\|.*\|\s*$/

export function slugifyForSanityText(str: string) {
  str = str.replace(/^\s+|\s+$/g, '') // trim leading/trailing white space
  str = str.toLowerCase() // convert string to lowercase
  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-') // remove consecutive hyphens
  return str
}

// Translucent, so it tints whatever surface the rich text sits on.
export const INLINE_BLOCK_BACKGROUND =
  'color-mix(in srgb, var(--moon-dust-darker) 60%, transparent)'
